import {Category} from '@digital-supply-chain/module'
import {ApiService} from "@/libs";
import {DataService} from "@/service";

export class TreeService {
  static tree:any = {}
  static async get(pid: Number = 0, CategoryId: Number, data: any = {}, query:string="") {
    if(!this.tree[CategoryId.toString()]) {
      this.tree[CategoryId.toString()] = {};
    } else {
      if(!this.tree[CategoryId.toString()][pid.toString()]) {
        this.tree[CategoryId.toString()][pid.toString()] = '';
      }
    }
    try {
      let url = "";
      if (pid == -1) {//授权给我
        url = `${ApiService.JrzzApi}/dir/${CategoryId}/shares`;
        let result = await DataService.get(url);
        let list = result.map((item: any) => Object.assign(item, {isShare: 1, TreeID: `shared_auth_${item.DirID}`}));
        this.tree[CategoryId.toString()][pid.toString()] = list;
        return list;
      } else {//我的资源
        url = `${ApiService.JrzzApi}/dir/${CategoryId}/list?dirId=${pid || 0}${query}`;
        // area=2，不进行权限认证获取企业所有的目录数据
        if(CategoryId == Category.ProdDir) {
          url += '&area=2';
        }
        if([Category.EnterpriseShare, Category.LectoFavoriteDirShare].includes(Number(CategoryId))) {
          url += '&area=2';
        }
        let result = await DataService.get(url);
        if (data.isShare) {
          let res =  result.map((item: any) => Object.assign(item, {isShare: 1, TreeID: `shared_${item.DirID}`}));
          this.tree[CategoryId.toString()][pid.toString()] = res;
          return res;
        } else {
          let res = result.map((item: any) => Object.assign(item, {TreeID: `list_${item.DirID}`}));
          this.tree[CategoryId.toString()][pid.toString()] = res;
          return res;
        }
      }
    } catch (error) {
      console.error(error.message || "");
    }
  }
  //获取企业产品分类
  static async getProdClasses(ClassType:number = 1) {
    // 1 通用 2 专用
    let data = await DataService.get(`${ApiService.JrzzApi}/prod/GetProdClasses?ClassType=${ClassType}`)
    let newData = data.map((_data:any)=>{
      return {DirID:_data.ID,TreeID:`class_${_data.ID}`,ParentID:_data.ParentID,DirName:_data.CName,IsLeaf:true};
    })
    return newData;
  }
  static async insert(OwnerCategoryID: any, ParentID: string, DirName: string, DirRemark: string,ShareArea:number = 0) {
    try {
      let postData:any = {
        OwnerCategoryID,
        ParentID,
        DirName,
        DirRemark
      };
      Category.ProdDir == OwnerCategoryID && (postData.ShareArea = ShareArea);
      return await DataService.post(`${ApiService.JrzzApi}/dir/${OwnerCategoryID}/add`,postData );
    } catch (e) {
      throw e;
    }
  }

  static async modify(dataId: string, OwnerCategoryID: any, ParentID: string, DirName: string, DirRemark: string,ShareArea:number = 0) {
    try {
      let postData:any = {
        OwnerCategoryID,
        ParentID,
        DirName,
        DirRemark
      };
      Category.ProdDir == OwnerCategoryID && (postData.ShareArea = ShareArea);
      return await DataService.post(`${ApiService.JrzzApi}/dir/${OwnerCategoryID}/update?dirId=${dataId}`, postData)
    } catch (e) {
      throw e;
    }
  }

  static async del(OwnerCategoryID: string, dirIds: Array<number>) {
    try {
      return await DataService.post(`${ApiService.JrzzApi}/dir/${OwnerCategoryID}/batchdelete`, dirIds);
    } catch (e) {
      throw e;
    }
  }

  static async saveDirSort(categoryId: number, idArray: Array<number>) {
    let url = `${ApiService.JrzzApi}/sort/${categoryId}/save`;
    return await DataService.post(url, idArray);
  }

  // 获取企业产品目录
  static async getProdDirList(compId: number) {
    let url = `${ApiService.JrzzApi}/prod/dir/getList?compId=${compId}`;
    return await DataService.get(url)
  }

  // 获取指定企业的自定义目录列表
  static async getProddirList2(compId: number, dirId: number, layer: number) {
    let url = "";
    url = `${ApiService.JrzzApi}/site/comp/proddir/list?compId=${compId}&dirId=${dirId}&layer=${layer}`;
    let result = await DataService.get(url);
    let res = result.map((item: any) => Object.assign(item, {TreeID: `list_${item.DirID}`}));
    return res;
  }

  // 私有模型目录 
  static async getPrivateModelDirList(resId: number, pid: number = 0){
    // let url = `${ApiService.Pdm}/model/dir/list?resId=${resId}&pid=${pid}`;
    // let result = await DataService.get(url);
    // return result;
  }

  // 添加私有模型目录
  static async addPrivateModelDir(resId: number, entity: any) {
    // let url = `${ApiService.Pdm}/model/dir/add?resId=${resId}`
    // return await DataService.post(url, entity);
  }
}